<!--start section header-->
 
<header class="head">
    <div class="cover">
        <div class="container d-flex justify-content-center align-items-center pt-5">
         <div>
             <h2 class="pt-5 d-flex justify-content-center">
                Mosaic
             </h2>
             <nav aria-label="breadcrumb">
                 <ol class="breadcrumb d-flex justify-content-center">
                   <li (click) = change() class="breadcrumb-item">
                       <a>Home</a>
                     </li>
                   <li class="breadcrumb-item active" aria-current="page">Mosaic</li>
                 </ol>
             </nav>
         </div>
 
        </div>
    </div>
 
 </header>
 
 <!--end section header-->

 <!--start section drugs-->

<section class="py-5 container drugs">
    <div class="row pt-5">

        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/b.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Top 8 Easy Ways to Get Rapid Cash</h5>
                  <p class="card-text">There may be any number of reasons <br>
                     why you need some cash in hand <br>
                      quickly.
                  </p>
                  <hr>
                  <div class="text-center pt-2 card-footers">
                     <p>
                       Read More
                     </p>     
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/h.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">How do Title Loans Actually Work?</h5>
                  <p class="card-text">When you need money right away and <br>
                     no help is available from a family...
                  </p>
                  <hr>
                  <div class="text-center pt-2 card-footers">
                     <p>
                       Read More
                     </p>     
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/e.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Creative Cash Flow Options</h5>
                  <p class="card-text">A common barrier to starting business <br>
                     securing the funding needed...
                  </p>
                  <hr>
                  <div class="text-center pt-2 card-footers">
                     <p>
                       Read More
                     </p>     
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/z.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Top 8 Easy Ways to Get Rapid Cash</h5>
                  <p class="card-text">There may be any number of reasons <br>
                     why you need some cash in hand <br>
                      quickly.
                  </p>
                  <hr>
                  <div class="text-center pt-2 card-footers">
                     <p>
                       Read More
                     </p>     
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/w.jpg" class="card-img-top img-fluid" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">How do Title Loans Actually Work?</h5>
                  <p class="card-text">When you need money right away and <br>
                     no help is available from a family...
                  </p>
                  <hr>
                  <div class="text-center pt-2 card-footers">
                     <p>
                       Read More
                     </p>     
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card text-center">
                <img src="assets/images/i.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Creative Cash Flow Options</h5>
                  <p class="card-text">A common barrier to starting business <br>
                     securing the funding needed...
                  </p>
                  <hr>
                  <div class="text-center pt-2 card-footers">
                     <p>
                       Read More
                     </p>     
                  </div>
                </div>
              </div>
        </div>
        

    </div>
</section>

<!--end section Drugs-->

<!--spinner-->

<section class="container pb-5 text-center">
    <img src="assets/images/loading.png" class="fa-spin" alt="loading">

</section>

<!--spinner-->
